import { useDispatch, useSelector } from "react-redux";
import BaseTextField from "../../../../components/ui/BaseTextField";
import {
  updateWorkOrderForm,
  updateWorkOrderFormValidation,
} from "../../../../store/workOrder/workOrderSlice";

const EngineerFixedPay = () => {
  const dispatch = useDispatch();
  const payment = useSelector((state) => state.workOrder.payment.pay);

  const workOrderFormValidation = useSelector(
    (state) => state.workOrder.workOrderFormValidation
  );
  const handleChange = (event) => {
    const { name, value } = event.target;
    const parsedValue = parseFloat(value);
    dispatch(
      updateWorkOrderForm({
        step: "payment",
        data: {
          pay: {
            [name]: value,
          },
        },
      })
    );

    if (name === "engineerFixedAmount" && parsedValue > 0) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "engineerFixedAmountError",
          data: false,
        })
      );
    }
    if (name === "engineerFixedAmount" && (!value || parsedValue <= 0)) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "engineerFixedAmountError",
          data: true,
        })
      );
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "engineerFixedAmountErrorMsg",
          data: "Fixed Rate is required",
        })
      );
    }
  };

  return (
    <div className="grid grid-cols-2 gap-y-4 mt-3">
      <div className="mr-10">
        <BaseTextField
          fullWidth
          fullHeight={false}
          label="Total Pay"
          requirement="required"
          labelShrink={false}
          error={workOrderFormValidation.engineerFixedAmountError}
          errorMsg={workOrderFormValidation.engineerFixedAmountErrorMsg}
          id="engineerFixedAmount"
          name="engineerFixedAmount"
          value={payment.engineerFixedAmount}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
      </div>
      {/*  <div>
        <BaseTextField
          fullWidth
          fullHeight={false}
          id="title"
          label="Approximate hours to complete"
          optional={false}
          labelShrink={false}
          // value={formik.values.title}
          // onChange={formik.handleChange}

          isDefaultField={false}
        />
        <p className="mt-2 text-sm text-right">
          Let provider know how long they will be on the site
        </p>
      </div> */}
    </div>
  );
};

export default EngineerFixedPay;
